import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import { formatNumberWithPeriods, formatRatingAverage } from 'helpers/formatters'

import CardHeading from '../CardHeading'
import SnippetsList from './components/SnippetsList'

import classes from './IntegrationCard.module.scss'

/** @type {import("./types").default} */
const IntegrationCard = ({ integration, className, ...props }) => {
  const { sendEvent } = useEventContext()

  return (
    <Grid className={clsx('IntegrationCard', classes.root, className)} {...props}>
      <div className={classes.headingContainer}>
        <CardHeading integration={integration} />
        <Typography
          className={classes.ratingText}
          variant="body2"
          onMouseOver={() =>
            sendEvent({
              name: 'engagement_hover',
              engagementComponent: 'product_integrations',
              engagementDestination: 'show_importance-definition',
              engagementDetails: 'hover_importance',
            })
          }
        >
          Integration rating: <b>{formatRatingAverage(integration.avg_integration_rating)}</b> (
          {formatNumberWithPeriods(integration.cnt_integration_rating)})
        </Typography>
      </div>

      <SnippetsList list={integration.summaries} />
    </Grid>
  )
}
export default IntegrationCard
